import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "services/authService";

function ProtectedRoute({ children }) {
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      if (!AuthService.isAuthenticated()) {
        setIsValid(false);
        return;
      }

      try {
        // Verify token is still valid by calling the /me endpoint
        await AuthService.getCurrentUser();
        setIsValid(true);
      } catch (error) {
        // Token is invalid, clear it and redirect to login
        AuthService.logout();
        setIsValid(false);
      }
    };

    checkAuth();
  }, []);

  if (isValid === null) return <div>Loading...</div>;
  if (!isValid) return <Navigate to="/authentication/sign-in" replace />;
  return children;
}

export default ProtectedRoute;